import { ItemID } from "types/common";

import { defaultTimeToLive } from "consts";

import { useGetItemPrices } from "api/useGetItemPrices/useGetItemPrices";

export const useGetItemPricesWithCache = (itemID: ItemID) => {
  return useGetItemPrices(itemID, defaultTimeToLive);
}
